<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            font-weight: 600;
          "
        >
          Facility Management
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col
                  v-for="item in ListData"
                  :key="item.id"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <v-card class="room-card" max-width="430">
                    <div class="image-wrapper">
                      <v-img
                        :src="item.image"
                        height="250"
                        class="room-image"
                      ></v-img>
                      <div class="image-gradient"></div>
                    </div>
                    <v-card-text class="text-center pt-6">
                      <div class="room-title">
                        {{ item.name }}
                      </div>
                      <div class="room-location pt-3">
                        {{ item.locationName }}
                      </div>

                      <div class="room-utilities">
                        <span
                          v-for="item2 in item.utility"
                          :key="item2.id"
                          class="utility-item"
                        >
                          {{ item2.name }} ({{ item2.amount }})
                        </span>
                      </div>

                      <div class="room-actions">
                        <v-btn
                          class="btn-booking"
                          @click="openEditDataFacility(item.id)"
                          >Edit</v-btn
                        >

                        <v-btn class="btn-all-booking">Delete</v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    label="10/page"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="FacilityDialog" max-width="900" persistent>
      <v-card class="facility-card">
        <v-card-title class="facility-header">
          <div class="d-flex align-center">
            <v-icon class="mr-3">mdi-office-building</v-icon>
            <span class="text-h6 font-weight-bold">Facility Information</span>
          </div>
          <v-btn icon @click="FacilityDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Facility Name"
                  v-model="FacilityName"
                  outlined
                  dense
                  prepend-inner-icon="mdi-domain"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="['Room', 'Space']"
                  label="Room Type"
                  v-model="RoomType"
                  outlined
                  dense
                  prepend-inner-icon="mdi-door"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  :items="['Reserve']"
                  label="Event Type"
                  v-model="EventType"
                  outlined
                  dense
                  prepend-inner-icon="mdi-calendar"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="LocationList"
                  item-value="locationID"
                  item-text="locationName"
                  label="Location"
                  v-model="Location"
                  outlined
                  dense
                  prepend-inner-icon="mdi-map-marker"
                />
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <div class="image-box">
                  <v-img :src="urlImg" height="200" cover></v-img>
                  <div class="upload-overlay">
                    <v-file-input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      hide-details
                      dense
                      v-model="FacilityImage"
                      @change="Preview_image"
                    ></v-file-input>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="status-card" outlined>
                  <div class="text-subtitle-1 font-weight-bold mb-2">
                    Status
                  </div>
                  <v-switch
                    v-model="Active"
                    inset
                    :label="Active ? 'Active' : 'Inactive'"
                    color="green"
                  ></v-switch>
                </v-card>
              </v-col>
            </v-row>
            <div class="section-title mt-6">
              <v-icon class="mr-2">mdi-tools</v-icon>
              Utilities
            </div>

            <v-row class="mt-2">
              <v-col cols="12">
                <v-card outlined class="utility-card">
                  <v-data-table
                    :headers="headers"
                    :items="UtilitysList"
                    :items-per-page="5"
                    class="elevation-1"
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td>{{ index + 1 }}</td>
                        <td class="font-weight-medium">
                          {{ item.utilityName }}
                        </td>
                        <td style="max-width: 50px">
                          <v-text-field
                            v-model="item.amount"
                            dense
                            outlined
                            hide-details
                            type="number"
                          ></v-text-field>
                        </td>

                        <td class="text-center">
                          <v-btn
                            class="text-capitalize"
                            icon
                            color="red"
                          >
                            <v-icon>mdi-delete</v-icon> Delete
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-6 justify-end">
          <v-btn
            variant="outlined"
            color="green"
            width="120"
            append-icon="mdi-close-circle-outline"
            class="px-6 white--text"
          >
            Update
          </v-btn>
          <v-btn
            variant="outlined"
            color="silver"
            width="120"
            class="px-6"
            @click="FacilityDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
// import { Image } from "pdfjs";

export default {
  name: "Facility",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,

      ListData: [],
      FacilityDialog: false,
      LocationList: [],
      FacilityName: "",
      RoomType: null,
      EventType: null,
      Location: null,
      FacilityImage: null,
      urlImg: null,
      base64: "",
      Active: null,
      UtilitysList: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          align: "left",
          value: "no",
        },
        {
          text: "UtilityName",
          align: "left",
          value: "projectName",
          sortable: false,
        },
        {
          text: "Amount",
          align: "left",
          value: "towerName",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.getDataFacility();
    await self.getDataDropdownLocation();
  },

  watch: {
    FacilityImage(newVal) {
      if (newVal) {
        this.createBase64Image();
      } else {
        this.base64 = "";
        this.FacilityImage = null;
      }
    },
  },

  methods: {
    async getDataFacility() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
      };
      await axios
        .post(`${self.url}Facility/getDataFacility`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Facility/getDataFacility`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Facility/getDataFacility`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    Preview_image() {
      this.urlImg = URL.createObjectURL(this.FacilityImage);
    },

    getDataDropdownLocation() {
      let self = this;
      axios
        .get(`${self.url}Utility/getDataDropdownLocation`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LocationList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        });
    },

    getDetailDataFacilityByID(id) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        facilityID: id,
      };
      axios
        .post(`${self.url}Facility/getDetailDataFacilityByID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            console.log(response.data.data);
            self.FacilityName = response.data.data.facilityName;
            self.RoomType =
              response.data.data.roomType == 1
                ? "Room"
                : response.data.data.roomType == 2
                ? "Space"
                : null;
            self.EventType =
              response.data.data.eventType == 1 ? "Reserve" : null;
            self.Location = response.data.data.location;
            self.FacilityImage = response.data.data.image;
            self.UtilitysList = response.data.data.utilityDetail;
            self.urlImg = response.data.data.image;
            self.base64 = response.data.data.image;
            self.Active =
              response.data.data.active == true ? "Active" : "InActive";
            self.FacilityDialog = true;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    openEditDataFacility(id) {
      let self = this;
      self.getDetailDataFacilityByID(id);
    },

    createBase64Image() {
      let self = this;
      const reader = new FileReader();
      reader.readAsDataURL(this.FacilityImage);
      reader.name = this.FacilityImage.name;
      reader.size = this.FacilityImage.size;
      reader.onload = (event) => {
        var img = new Image();
        img.src = event.target.result;
        img.name = event.target.name;
        img.size = event.target.size;
        img.onload = function (el) {
          var elem = document.createElement("canvas");
          var scaleFactor = 400 / el.target.width;
          elem.width = 400;
          elem.height = el.target.height * scaleFactor;
          var ctx = elem.getContext("2d");
          ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
          var srcEncoded = ctx.canvas.toDataURL("image/png", 1);
          self.base64 = srcEncoded;
        };
      };
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    ConvertNameStatus(Name) {
      if (Name != "") {
        if (Name == "Active") {
          return this.$t("message.Active");
        } else if (Name == "Expired") {
          return this.$t("message.Expired");
        } else {
          return this.$t("message.Rejected");
        }
      }
      return "";
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.label-col {
  text-align: right;
}

@media (max-width: 960px) {
  .label-col {
    text-align: left;
  }
}

.label-text {
  font-size: 18px;
  font-weight: 500;
  color: #555;
  margin: 8px 0;
}

.value-text {
  font-size: 18px;
  font-weight: 600;
  color: #111;
  margin: 8px 0;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.room-card {
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* IMAGE */
.image-wrapper {
  position: relative;
}

.room-image {
  border-radius: 30px 30px 0 0;
}

.image-gradient {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(0, 40, 120, 0.4)
  );
}

.room-title {
  font-size: 32px;
  font-weight: 800;
  color: #0d3b8f;
}

.room-location {
  margin-top: 4px;
  font-size: 16px;
  color: #444;
}

.room-utilities {
  margin-top: 8px;
}

.utility-item {
  font-size: 14px;
  color: #e47d83;
  margin-right: 10px;
}

.room-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.btn-booking {
  background: #0d3b8f !important;
  color: white !important;
  border-radius: 30px;
  padding: 8px 28px;
  text-transform: none;
  width: 130px;
}

.btn-all-booking {
  background: #ebeae9 !important;
  color: #0d3b8f !important;
  border-radius: 30px;
  padding: 8px 28px;
  text-transform: none;
  width: 130px;
}

.facility-card {
  border-radius: 16px;
}

.facility-header {
  background: linear-gradient(135deg, #1a1a1a, #333);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.image-box {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  position: relative;
}

.upload-overlay {
  padding: 10px;
}

.status-card {
  padding: 20px;
  border-radius: 10px;
}

.utility-card {
  border-radius: 10px;
}

.utility-table {
  border-radius: 10px;
}

.utility-table .v-data-table-header {
  background: #f5f7fb;
  font-weight: 600;
}
</style>
  